// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images//show-toyota.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/images//show-lexus.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/images//hide-toyota.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../assets/images//hide-lexus.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../assets/images//active-flag.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../assets/images//inactive-flag.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../assets/images//calendar.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.certification-Container {
    font-size: 0.81rem;
    font-family: "Arial", sans-serif;
    max-width: 1300px !important;
    /* margin-left : 1rem !important;
    margin-right : 1rem !important; */
    border-top-right-radius: 1.25rem;
    border-top-left-radius: 1.25rem;
    border-bottom-right-radius: 1.25rem;
    border-bottom-left-radius: 1.25rem;
    background-color: #f0f0f0;
    padding: 1.25rem;
}

.certification-Container-top {
    font-size: 0.81rem;
    font-family: "Arial", sans-serif;
    max-width: 1300px !important;
    /* margin-left : 1rem !important;
    margin-right : 1rem !important; */
    border-top-right-radius: 1.25rem;
    border-top-left-radius: 1.25rem;
    background-color: #f0f0f0;
    padding: 1.25rem;
}

.certification-Container-middle {
    font-size: 0.81rem;
    font-family: "Arial", sans-serif;
    max-width: 1300px !important;
    /* margin-left : 1rem !important;
    margin-right : 1rem !important; */
    background-color: #f0f0f0;
    padding: 1.25rem;
}

.certification-Container-bottom {
    font-size: 0.81rem;
    font-family: "Arial", sans-serif;
    max-width: 1300px !important;
    /* margin-left : 1rem !important;
    margin-right : 1rem !important; */
    border-bottom-right-radius: 1.25rem;
    border-bottom-left-radius: 1.25rem;
    background-color: #f0f0f0;
    padding: 1.25rem;
}

.lexus-FontWithBold {
    color: #252525;
    font-weight: bold;
    padding-left: 1rem !important;
    padding-top: 1.0rem;
    margin-top: 0.2rem;
}

.toyota-FontWithBold {
    color: #e50000;
    font-weight: bold;
    padding-left: 1rem !important;
    padding-top: 1.0rem;
    margin-top: 0.2rem;
}

.searchCertificationTable {
    padding: 1rem;
    min-height: 300px !important;
}
.boldFont {
    font-weight: bold;
    padding-top: 1.0rem;
}
.toyota-show-icon {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    height: 19px;
    width: 19px;
    background-position: center;
    margin: 0 0.3rem;
}

.lexus-show-icon {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    height: 19px;
    width: 19px;
    background-position: center;
    margin: 0 0.3rem;
}

.toyota-hide-icon {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    height: 19px;
    width: 19px;
    background-position: center;
    margin: 0 0.3rem;
}

.lexus-hide-icon {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
    height: 19px;
    width: 19px;
    background-position: center;
    margin: 0 0.3rem;
}

.certificationContainer {
    font-size: 0.81rem;
    font-family: "Arial", sans-serif;
    max-width: none !important;
    margin-bottom: 3rem;
}

.certificationTableContainer .tab-content {
    border-bottom-right-radius: 1.25rem;
    border-bottom-left-radius: 1.25rem;
    border-top-right-radius: 1.25rem;
    background-color: #f0f0f0;
    padding: 1.25rem;
    /* height: 33rem;
    width: 81.5rem; */
}

.certificationTableContainer .certification-content {
    border-bottom-right-radius: 1.25rem;
    border-bottom-left-radius: 1.25rem;
    border-top-right-radius: 1.25rem;
    border-top-left-radius: 1.25rem;
    background-color: #f0f0f0;
    /* width: 81.5rem; */
}

.searchCertificationTable {
    padding: 1rem;
    min-height: 300px !important;
}





.searchCertificationTable .active-flag {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
    height: 18px;
    width: 18px;
    background-position: center;
    margin: 0 0.3rem;
    margin-left: 2.03rem;
}

.searchCertificationTable .inactive-flag {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
    height: 18px;
    width: 18px;
    background-position: center;
    margin: 0 0.3rem;
    margin-left: 2.03rem;
}

.certificateTable tbody, .certificateTable tr {
    display: block;
}

.certificateTable tr:after {
    content: ' ';
    display: block;
    visibility: hidden;
    clear: both;
}

.certificateTable tbody {
    height: 74vh;
    overflow-y: scroll;
}

.certificateTable table {
    border-spacing: 3px 7px;
    border-collapse: separate;
    margin-bottom: 0px !important;
}

.certificateTable tbody>tr>td {
    width: 7rem;
    float: left;
    text-overflow: ellipsis;
    overflow: hidden;
}

.certificateTable thead>tr>th {
    width: 7rem;
    float: left;
}
div.certificateTable div.row.react-bootstrap-table-pagination div {
    padding: 0px !important;
}

.parent-toyota #pageDropDown {
    background-color: #E50000 !important;
}

.parent-lexus #pageDropDown {
    background-color: #252525 !important;
}

.pagination {
    float: right;
}

.parent-toyota .pagination .active>a {
    background-color: #E50000 !important;
}

.parent-lexus .pagination .active>a {
    background-color: #252525 !important;
}




/* css for search */
.search {
    padding: 1rem;
    border-left: 6px solid;
    border-left-color: #e50000;
    border-right: 6px solid;
    border-right-color: #e50000;
    border-top: 1px solid;
    border-top-color: #000000;
    border-bottom: 1px solid;
    border-bottom-color: #000000;
}

.fa.fa-times{
    font-size: x-large;
    color: red;

}
.fa.fa-check{
    font-size: x-large;
    color: green;

}

.certificateTable .dropdown-menu {
    top: -18px;
    left: 104px;
    font-size: 12px;
}
.queslink:hover {
    color: #e50000;
    cursor: pointer;
  }

.certificationDetailsModal .css-10nd86i {
    width: 50%;
}

.certificationDetailsModal-toyota .css-10nd86i svg {
    color: #e50000;
}

.certificationDetailsModal-lexus .css-10nd86i svg {
    color: #252525;
}

.certificationDetailsModal .css-10nd86i .css-1492t68 {
    text-indent: -9999px;
}

.certificationDetailsModal .css-va7pk8 {
    color: #595d60 !important;
}

.modal-body {
    font-size: 0.81rem;
    color: #595d60;
    padding: 0.7rem !important;
}

.certificationDetailsModal tbody {
    overflow-y: scroll;
    border: solid 1px #a8aaac;
    height: 30rem !important;
    display: block;
    width: 77rem;
}

.certificationDetailsModal .table > tbody > tr > td.react-bs-table-no-data {
    width: 78rem !important;
} 


.certificationDetailsModal {
    max-width: 79rem !important;
}

.certificationDetailsModal .table > tbody > tr > td {
    word-wrap: break-word;
} 


.certificationDetailsModal-toyota .modal-dialog, .certificationDetailsModal-toyota .modal-content {
    border-radius: 24px !important;
    border: 0px solid #e50000 !important;
}

.certificationDetailsModal-lexus .modal-dialog, .certificationDetailsModal-lexus .modal-content {
    border-radius: 24px !important;
    border: 0px solid #252525 !important;
}

.certificationDetailsModal-toyota .modal-header {
    background-color: #e50000;
    border-top-left-radius: 20px !important;
    border-top-right-radius: 20px !important;
    padding: 0.5rem !important;
}

.certificationDetailsModal-lexus .modal-header {
    background-color: #252525;
    border-top-left-radius: 20px !important;
    border-top-right-radius: 20px !important;
    padding: 0.5rem !important;
}

.certificationDetailsModal .table > tbody > tr {
    width: 100%;
    /* float: left; */
} 


  .certificationDetailsMain  .modal.fade.top.show{
    overflow-y: auto !important;
  }

  .react-autosuggest__input{
    padding: 10px 10px;
    border: 0px solid #aaa;
    border-color: rgb(219, 212, 212);
    border-radius: 0.25rem !important;
    width: 12.7rem;
  }

  .searchActivity {
    padding: 1rem;
    border-left: 6px solid;
    border-left-color: #e50000;
    border-right: 6px solid;
    border-right-color: #e50000;
    border-top: 1px solid;
    border-top-color: #000000;
    border-bottom: 1px solid;
    border-bottom-color: #000000;
}

.hrClass {
    padding: 0px !important;
}

.searchActivity .noPadding {
    padding: 0px;
}

.searchActivity .css-10nd86i svg {
    color: #e50000;
}

.searchActivity .css-1492t68 {
    text-indent: -9999px;
}

.searchActivity .css-va7pk8 {
    color: #595d60 !important;
}

.searchActivity .react-datepicker__input-container {
    width: 11.7rem;
}

.bigDD-toyota .react-datepicker__close-icon::after {
    background-color: #e50000;
}

.bigDD-lexus .react-datepicker__close-icon::after {
    background-color: #252525;
}

.searchActivity #startDate, .searchActivity #completeDate, .searchActivity #startDateTo, .searchActivity #completeDateTo {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
    background-repeat: no-repeat;
    background-position: right;
    cursor: pointer;
}

.Select-menu-outer {
    max-height: 1000px;
}

.Select-menu {
    max-height: 998px;
}

.bigDD-toyota .css-1r4vtzz, .bigDD-toyota .css-48ayfv, .bigDD-lexus .css-1r4vtzz, .bigDD-lexus .css-48ayfv {
    width: 11.7rem;
}

.bigDD-toyota .css-1r4vtzz svg, .bigDD-toyota .css-48ayfv svg {
    color: #e50000 !important;
}

.bigDD-lexus .css-1r4vtzz svg, .bigDD-lexus .css-48ayfv svg {
    color: #252525 !important;
}

.smallDD-toyota .css-1r4vtzz svg, .smallDD-toyota .css-48ayfv svg {
    color: #e50000 !important;
}

.smallDD-lexus .css-1r4vtzz svg, .smallDD-lexus .css-48ayfv svg {
    color: #252525 !important;
}

.smallDD-toyota .css-1r4vtzz, .smallDD-toyota .css-48ayfv, .smallDD-toyota .react-datepicker__input-container, .smallDD-lexus .css-1r4vtzz, .smallDD-lexus .css-48ayfv, .smallDD-lexus .react-datepicker__input-container {
    width: 9rem;
}

.searchActivity .react-autosuggest__container {
    position: relative;
}

.searchActivity .react-autosuggest__input {
    padding: 10px 10px;
    border: 1px solid #aaa;
    border-color: rgb(219, 212, 212);
    border-radius: 0.25rem !important;
    height: calc(2.25rem + 2px);
    width: 11.7rem;

}

/* .addEditActivityModal .react-autosuggest__input--focused {
    border-radius: 0.25rem !important;
  } */

.searchActivity .react-autosuggest__input--open {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    border-radius: 0.25rem !important;
    height: calc(2.25rem + 2px);
    width: 11.7rem;
    
}

.searchActivity .react-autosuggest__suggestions-container--open {
    display: block;
    min-width: 11.7rem;
    border: 1px solid #aaa;
    border-radius: 0.25rem !important;
}

.searchActivity .react-autosuggest__suggestions-list {
    margin: 0;
    padding: 0;
    list-style-type: none;
}

.searchActivity .react-autosuggest__suggestion {
    cursor: pointer;
    padding: 10px 20px;
    background-color: white;
}

.searchActivity .react-autosuggest__suggestion--highlighted {
    background-color: #ddd;
}

#react-autowhatever-1 {
    position: absolute;
    z-index: 9999;
    background: white;
}

.css-15brt4p {
    display: none !important;
}

.css-11unzgr {
    border: 0.5px solid #aaa !important;
}

.noMargin.button-toyota {
    margin : 0px !important;
}

.noMargin.button-lexus {
    margin : 0px !important;
}
.searchIcon-toyota{
    color: #e50000 !important;
}

.searchIcon-lexus{
color: #252525 !important
}
`, "",{"version":3,"sources":["webpack://./src/components/certification/index.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,gCAAgC;IAChC,4BAA4B;IAC5B;qCACiC;IACjC,gCAAgC;IAChC,+BAA+B;IAC/B,mCAAmC;IACnC,kCAAkC;IAClC,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,gCAAgC;IAChC,4BAA4B;IAC5B;qCACiC;IACjC,gCAAgC;IAChC,+BAA+B;IAC/B,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,gCAAgC;IAChC,4BAA4B;IAC5B;qCACiC;IACjC,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,gCAAgC;IAChC,4BAA4B;IAC5B;qCACiC;IACjC,mCAAmC;IACnC,kCAAkC;IAClC,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,6BAA6B;IAC7B,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,6BAA6B;IAC7B,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,4BAA4B;AAChC;AACA;IACI,iBAAiB;IACjB,mBAAmB;AACvB;AACA;IACI,yDAA6D;IAC7D,YAAY;IACZ,WAAW;IACX,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;IACI,yDAA4D;IAC5D,YAAY;IACZ,WAAW;IACX,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;IACI,yDAA6D;IAC7D,YAAY;IACZ,WAAW;IACX,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;IACI,yDAA4D;IAC5D,YAAY;IACZ,WAAW;IACX,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,gCAAgC;IAChC,0BAA0B;IAC1B,mBAAmB;AACvB;;AAEA;IACI,mCAAmC;IACnC,kCAAkC;IAClC,gCAAgC;IAChC,yBAAyB;IACzB,gBAAgB;IAChB;qBACiB;AACrB;;AAEA;IACI,mCAAmC;IACnC,kCAAkC;IAClC,gCAAgC;IAChC,+BAA+B;IAC/B,yBAAyB;IACzB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,4BAA4B;AAChC;;;;;;AAMA;IACI,yDAA6D;IAC7D,YAAY;IACZ,WAAW;IACX,2BAA2B;IAC3B,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,yDAA+D;IAC/D,YAAY;IACZ,WAAW;IACX,2BAA2B;IAC3B,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,yBAAyB;IACzB,6BAA6B;AACjC;;AAEA;IACI,WAAW;IACX,WAAW;IACX,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,WAAW;AACf;AACA;IACI,uBAAuB;AAC3B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;;;;AAKA,mBAAmB;AACnB;IACI,aAAa;IACb,sBAAsB;IACtB,0BAA0B;IAC1B,uBAAuB;IACvB,2BAA2B;IAC3B,qBAAqB;IACrB,yBAAyB;IACzB,wBAAwB;IACxB,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;IAClB,UAAU;;AAEd;AACA;IACI,kBAAkB;IAClB,YAAY;;AAEhB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,eAAe;AACnB;AACA;IACI,cAAc;IACd,eAAe;EACjB;;AAEF;IACI,UAAU;AACd;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,wBAAwB;IACxB,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;;AAGA;IACI,2BAA2B;AAC/B;;AAEA;IACI,qBAAqB;AACzB;;;AAGA;IACI,8BAA8B;IAC9B,oCAAoC;AACxC;;AAEA;IACI,8BAA8B;IAC9B,oCAAoC;AACxC;;AAEA;IACI,yBAAyB;IACzB,uCAAuC;IACvC,wCAAwC;IACxC,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;IACzB,uCAAuC;IACvC,wCAAwC;IACxC,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,iBAAiB;AACrB;;;EAGE;IACE,2BAA2B;EAC7B;;EAEA;IACE,kBAAkB;IAClB,sBAAsB;IACtB,gCAAgC;IAChC,iCAAiC;IACjC,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,0BAA0B;IAC1B,uBAAuB;IACvB,2BAA2B;IAC3B,qBAAqB;IACrB,yBAAyB;IACzB,wBAAwB;IACxB,4BAA4B;AAChC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yDAA0D;IAC1D,4BAA4B;IAC5B,0BAA0B;IAC1B,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,gCAAgC;IAChC,iCAAiC;IACjC,2BAA2B;IAC3B,cAAc;;AAElB;;AAEA;;KAEK;;AAEL;IACI,4BAA4B;IAC5B,6BAA6B;IAC7B,iCAAiC;IACjC,2BAA2B;IAC3B,cAAc;;AAElB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,sBAAsB;IACtB,iCAAiC;AACrC;;AAEA;IACI,SAAS;IACT,UAAU;IACV,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;AAC3B;AACA;IACI,yBAAyB;AAC7B;;AAEA;AACA;AACA","sourcesContent":[".certification-Container {\n    font-size: 0.81rem;\n    font-family: \"Arial\", sans-serif;\n    max-width: 1300px !important;\n    /* margin-left : 1rem !important;\n    margin-right : 1rem !important; */\n    border-top-right-radius: 1.25rem;\n    border-top-left-radius: 1.25rem;\n    border-bottom-right-radius: 1.25rem;\n    border-bottom-left-radius: 1.25rem;\n    background-color: #f0f0f0;\n    padding: 1.25rem;\n}\n\n.certification-Container-top {\n    font-size: 0.81rem;\n    font-family: \"Arial\", sans-serif;\n    max-width: 1300px !important;\n    /* margin-left : 1rem !important;\n    margin-right : 1rem !important; */\n    border-top-right-radius: 1.25rem;\n    border-top-left-radius: 1.25rem;\n    background-color: #f0f0f0;\n    padding: 1.25rem;\n}\n\n.certification-Container-middle {\n    font-size: 0.81rem;\n    font-family: \"Arial\", sans-serif;\n    max-width: 1300px !important;\n    /* margin-left : 1rem !important;\n    margin-right : 1rem !important; */\n    background-color: #f0f0f0;\n    padding: 1.25rem;\n}\n\n.certification-Container-bottom {\n    font-size: 0.81rem;\n    font-family: \"Arial\", sans-serif;\n    max-width: 1300px !important;\n    /* margin-left : 1rem !important;\n    margin-right : 1rem !important; */\n    border-bottom-right-radius: 1.25rem;\n    border-bottom-left-radius: 1.25rem;\n    background-color: #f0f0f0;\n    padding: 1.25rem;\n}\n\n.lexus-FontWithBold {\n    color: #252525;\n    font-weight: bold;\n    padding-left: 1rem !important;\n    padding-top: 1.0rem;\n    margin-top: 0.2rem;\n}\n\n.toyota-FontWithBold {\n    color: #e50000;\n    font-weight: bold;\n    padding-left: 1rem !important;\n    padding-top: 1.0rem;\n    margin-top: 0.2rem;\n}\n\n.searchCertificationTable {\n    padding: 1rem;\n    min-height: 300px !important;\n}\n.boldFont {\n    font-weight: bold;\n    padding-top: 1.0rem;\n}\n.toyota-show-icon {\n    background-image: url(\"../../assets/images//show-toyota.png\");\n    height: 19px;\n    width: 19px;\n    background-position: center;\n    margin: 0 0.3rem;\n}\n\n.lexus-show-icon {\n    background-image: url(\"../../assets/images//show-lexus.png\");\n    height: 19px;\n    width: 19px;\n    background-position: center;\n    margin: 0 0.3rem;\n}\n\n.toyota-hide-icon {\n    background-image: url(\"../../assets/images//hide-toyota.png\");\n    height: 19px;\n    width: 19px;\n    background-position: center;\n    margin: 0 0.3rem;\n}\n\n.lexus-hide-icon {\n    background-image: url(\"../../assets/images//hide-lexus.png\");\n    height: 19px;\n    width: 19px;\n    background-position: center;\n    margin: 0 0.3rem;\n}\n\n.certificationContainer {\n    font-size: 0.81rem;\n    font-family: \"Arial\", sans-serif;\n    max-width: none !important;\n    margin-bottom: 3rem;\n}\n\n.certificationTableContainer .tab-content {\n    border-bottom-right-radius: 1.25rem;\n    border-bottom-left-radius: 1.25rem;\n    border-top-right-radius: 1.25rem;\n    background-color: #f0f0f0;\n    padding: 1.25rem;\n    /* height: 33rem;\n    width: 81.5rem; */\n}\n\n.certificationTableContainer .certification-content {\n    border-bottom-right-radius: 1.25rem;\n    border-bottom-left-radius: 1.25rem;\n    border-top-right-radius: 1.25rem;\n    border-top-left-radius: 1.25rem;\n    background-color: #f0f0f0;\n    /* width: 81.5rem; */\n}\n\n.searchCertificationTable {\n    padding: 1rem;\n    min-height: 300px !important;\n}\n\n\n\n\n\n.searchCertificationTable .active-flag {\n    background-image: url(\"../../assets/images//active-flag.png\");\n    height: 18px;\n    width: 18px;\n    background-position: center;\n    margin: 0 0.3rem;\n    margin-left: 2.03rem;\n}\n\n.searchCertificationTable .inactive-flag {\n    background-image: url(\"../../assets/images//inactive-flag.png\");\n    height: 18px;\n    width: 18px;\n    background-position: center;\n    margin: 0 0.3rem;\n    margin-left: 2.03rem;\n}\n\n.certificateTable tbody, .certificateTable tr {\n    display: block;\n}\n\n.certificateTable tr:after {\n    content: ' ';\n    display: block;\n    visibility: hidden;\n    clear: both;\n}\n\n.certificateTable tbody {\n    height: 74vh;\n    overflow-y: scroll;\n}\n\n.certificateTable table {\n    border-spacing: 3px 7px;\n    border-collapse: separate;\n    margin-bottom: 0px !important;\n}\n\n.certificateTable tbody>tr>td {\n    width: 7rem;\n    float: left;\n    text-overflow: ellipsis;\n    overflow: hidden;\n}\n\n.certificateTable thead>tr>th {\n    width: 7rem;\n    float: left;\n}\ndiv.certificateTable div.row.react-bootstrap-table-pagination div {\n    padding: 0px !important;\n}\n\n.parent-toyota #pageDropDown {\n    background-color: #E50000 !important;\n}\n\n.parent-lexus #pageDropDown {\n    background-color: #252525 !important;\n}\n\n.pagination {\n    float: right;\n}\n\n.parent-toyota .pagination .active>a {\n    background-color: #E50000 !important;\n}\n\n.parent-lexus .pagination .active>a {\n    background-color: #252525 !important;\n}\n\n\n\n\n/* css for search */\n.search {\n    padding: 1rem;\n    border-left: 6px solid;\n    border-left-color: #e50000;\n    border-right: 6px solid;\n    border-right-color: #e50000;\n    border-top: 1px solid;\n    border-top-color: #000000;\n    border-bottom: 1px solid;\n    border-bottom-color: #000000;\n}\n\n.fa.fa-times{\n    font-size: x-large;\n    color: red;\n\n}\n.fa.fa-check{\n    font-size: x-large;\n    color: green;\n\n}\n\n.certificateTable .dropdown-menu {\n    top: -18px;\n    left: 104px;\n    font-size: 12px;\n}\n.queslink:hover {\n    color: #e50000;\n    cursor: pointer;\n  }\n\n.certificationDetailsModal .css-10nd86i {\n    width: 50%;\n}\n\n.certificationDetailsModal-toyota .css-10nd86i svg {\n    color: #e50000;\n}\n\n.certificationDetailsModal-lexus .css-10nd86i svg {\n    color: #252525;\n}\n\n.certificationDetailsModal .css-10nd86i .css-1492t68 {\n    text-indent: -9999px;\n}\n\n.certificationDetailsModal .css-va7pk8 {\n    color: #595d60 !important;\n}\n\n.modal-body {\n    font-size: 0.81rem;\n    color: #595d60;\n    padding: 0.7rem !important;\n}\n\n.certificationDetailsModal tbody {\n    overflow-y: scroll;\n    border: solid 1px #a8aaac;\n    height: 30rem !important;\n    display: block;\n    width: 77rem;\n}\n\n.certificationDetailsModal .table > tbody > tr > td.react-bs-table-no-data {\n    width: 78rem !important;\n} \n\n\n.certificationDetailsModal {\n    max-width: 79rem !important;\n}\n\n.certificationDetailsModal .table > tbody > tr > td {\n    word-wrap: break-word;\n} \n\n\n.certificationDetailsModal-toyota .modal-dialog, .certificationDetailsModal-toyota .modal-content {\n    border-radius: 24px !important;\n    border: 0px solid #e50000 !important;\n}\n\n.certificationDetailsModal-lexus .modal-dialog, .certificationDetailsModal-lexus .modal-content {\n    border-radius: 24px !important;\n    border: 0px solid #252525 !important;\n}\n\n.certificationDetailsModal-toyota .modal-header {\n    background-color: #e50000;\n    border-top-left-radius: 20px !important;\n    border-top-right-radius: 20px !important;\n    padding: 0.5rem !important;\n}\n\n.certificationDetailsModal-lexus .modal-header {\n    background-color: #252525;\n    border-top-left-radius: 20px !important;\n    border-top-right-radius: 20px !important;\n    padding: 0.5rem !important;\n}\n\n.certificationDetailsModal .table > tbody > tr {\n    width: 100%;\n    /* float: left; */\n} \n\n\n  .certificationDetailsMain  .modal.fade.top.show{\n    overflow-y: auto !important;\n  }\n\n  .react-autosuggest__input{\n    padding: 10px 10px;\n    border: 0px solid #aaa;\n    border-color: rgb(219, 212, 212);\n    border-radius: 0.25rem !important;\n    width: 12.7rem;\n  }\n\n  .searchActivity {\n    padding: 1rem;\n    border-left: 6px solid;\n    border-left-color: #e50000;\n    border-right: 6px solid;\n    border-right-color: #e50000;\n    border-top: 1px solid;\n    border-top-color: #000000;\n    border-bottom: 1px solid;\n    border-bottom-color: #000000;\n}\n\n.hrClass {\n    padding: 0px !important;\n}\n\n.searchActivity .noPadding {\n    padding: 0px;\n}\n\n.searchActivity .css-10nd86i svg {\n    color: #e50000;\n}\n\n.searchActivity .css-1492t68 {\n    text-indent: -9999px;\n}\n\n.searchActivity .css-va7pk8 {\n    color: #595d60 !important;\n}\n\n.searchActivity .react-datepicker__input-container {\n    width: 11.7rem;\n}\n\n.bigDD-toyota .react-datepicker__close-icon::after {\n    background-color: #e50000;\n}\n\n.bigDD-lexus .react-datepicker__close-icon::after {\n    background-color: #252525;\n}\n\n.searchActivity #startDate, .searchActivity #completeDate, .searchActivity #startDateTo, .searchActivity #completeDateTo {\n    background-image: url(\"../../assets/images//calendar.png\");\n    background-repeat: no-repeat;\n    background-position: right;\n    cursor: pointer;\n}\n\n.Select-menu-outer {\n    max-height: 1000px;\n}\n\n.Select-menu {\n    max-height: 998px;\n}\n\n.bigDD-toyota .css-1r4vtzz, .bigDD-toyota .css-48ayfv, .bigDD-lexus .css-1r4vtzz, .bigDD-lexus .css-48ayfv {\n    width: 11.7rem;\n}\n\n.bigDD-toyota .css-1r4vtzz svg, .bigDD-toyota .css-48ayfv svg {\n    color: #e50000 !important;\n}\n\n.bigDD-lexus .css-1r4vtzz svg, .bigDD-lexus .css-48ayfv svg {\n    color: #252525 !important;\n}\n\n.smallDD-toyota .css-1r4vtzz svg, .smallDD-toyota .css-48ayfv svg {\n    color: #e50000 !important;\n}\n\n.smallDD-lexus .css-1r4vtzz svg, .smallDD-lexus .css-48ayfv svg {\n    color: #252525 !important;\n}\n\n.smallDD-toyota .css-1r4vtzz, .smallDD-toyota .css-48ayfv, .smallDD-toyota .react-datepicker__input-container, .smallDD-lexus .css-1r4vtzz, .smallDD-lexus .css-48ayfv, .smallDD-lexus .react-datepicker__input-container {\n    width: 9rem;\n}\n\n.searchActivity .react-autosuggest__container {\n    position: relative;\n}\n\n.searchActivity .react-autosuggest__input {\n    padding: 10px 10px;\n    border: 1px solid #aaa;\n    border-color: rgb(219, 212, 212);\n    border-radius: 0.25rem !important;\n    height: calc(2.25rem + 2px);\n    width: 11.7rem;\n\n}\n\n/* .addEditActivityModal .react-autosuggest__input--focused {\n    border-radius: 0.25rem !important;\n  } */\n\n.searchActivity .react-autosuggest__input--open {\n    border-bottom-left-radius: 0;\n    border-bottom-right-radius: 0;\n    border-radius: 0.25rem !important;\n    height: calc(2.25rem + 2px);\n    width: 11.7rem;\n    \n}\n\n.searchActivity .react-autosuggest__suggestions-container--open {\n    display: block;\n    min-width: 11.7rem;\n    border: 1px solid #aaa;\n    border-radius: 0.25rem !important;\n}\n\n.searchActivity .react-autosuggest__suggestions-list {\n    margin: 0;\n    padding: 0;\n    list-style-type: none;\n}\n\n.searchActivity .react-autosuggest__suggestion {\n    cursor: pointer;\n    padding: 10px 20px;\n    background-color: white;\n}\n\n.searchActivity .react-autosuggest__suggestion--highlighted {\n    background-color: #ddd;\n}\n\n#react-autowhatever-1 {\n    position: absolute;\n    z-index: 9999;\n    background: white;\n}\n\n.css-15brt4p {\n    display: none !important;\n}\n\n.css-11unzgr {\n    border: 0.5px solid #aaa !important;\n}\n\n.noMargin.button-toyota {\n    margin : 0px !important;\n}\n\n.noMargin.button-lexus {\n    margin : 0px !important;\n}\n.searchIcon-toyota{\n    color: #e50000 !important;\n}\n\n.searchIcon-lexus{\ncolor: #252525 !important\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
